import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect5InV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33 34H63V64" stroke="#FFDD00" strokeWidth="2" />
      <path d="M1 0L1 30L31 30" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
